import { Injectable } from '@angular/core';
import { doc, getDoc, setDoc, Timestamp } from 'firebase/firestore';
import { FirebaseService } from './firebase.service';

export interface EconEventsIndexDoc {
  events: Record<string, string[]>; // eventName → sorted array of YYYY-MM-DD dates
  savedAt: Timestamp;
}

@Injectable({ providedIn: 'root' })
export class EconEventsIndexService {
  private db: FirebaseService['db'];
  private cache: EconEventsIndexDoc | null = null;

  constructor(firebase: FirebaseService) {
    this.db = firebase.db;
  }

  async save(events: Record<string, string[]>): Promise<void> {
    await setDoc(doc(this.db, 'econEventsIndex', 'highImpact'), {
      events,
      savedAt: Timestamp.now(),
    });
    this.cache = null; // invalidate on write
  }

  async get(): Promise<EconEventsIndexDoc | null> {
    if (this.cache) return this.cache;
    const snap = await getDoc(doc(this.db, 'econEventsIndex', 'highImpact'));
    this.cache = snap.exists() ? (snap.data() as EconEventsIndexDoc) : null;
    return this.cache;
  }
}
